import { Component, OnInit } from '@angular/core';
import { FullLayoutComponent } from './layout/full-layout/full-layout.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { AuthService } from './services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { SpinnerService, SpinnerState } from './components/spinner/spinner.service';
import { FullscreenSpinnerComponent } from './components/spinner/fullscreen-spinner.component';
import { ChangePasswordModalComponent } from './components/change-password/change-password-modal.component';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [CommonModule, FullLayoutComponent, SignInComponent, FullscreenSpinnerComponent, RouterOutlet],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
	spinnerState: SpinnerState = { visible: false, message: 'Please wait...' };

	isPublicRoute = false;

	constructor(public authService: AuthService, private spinnerService: SpinnerService, private router: Router) { }

	ngOnInit() {

		this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
            // event.urlAfterRedirects ensures we check the FINAL url, even if a redirect happened
            this.isPublicRoute = event.urlAfterRedirects.startsWith('/secure-download');
        });

		this.spinnerService.spinnerState$.subscribe(state => {
			// defer update to avoid ExpressionChangedAfterItHasBeenCheckedError
			setTimeout(() => {
				this.spinnerState = state;
			});
		});
	}

	get authenticated() {
  		return this.authService.isAuthenticated();
	}
}
